var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { st, classes } from './ColorPicker.base.st.css';
import { ColorPickerItem } from './ColorPickerItem/ColorPickerItem';
import { ErrorMessageWrapper } from '../internal/ErrorMessageWrapper';
import { colorPickerFieldsetLabelDataHook } from './dataHooks';
import uniqueId from '../../common/uniqueId';
var ColorPickerBase = /** @class */ (function (_super) {
    __extends(ColorPickerBase, _super);
    function ColorPickerBase(props) {
        var _this = _super.call(this, props) || this;
        _this._errorMessageId = uniqueId('error-message');
        return _this;
    }
    ColorPickerBase.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, children = _a.children, className = _a.className, name = _a.name, errorMessage = _a.errorMessage, label = _a.label;
        var stStates = { error: !!errorMessage };
        return (React.createElement(ErrorMessageWrapper, __assign({}, {
            visible: !!errorMessage,
            message: errorMessage,
            messageId: this._errorMessageId,
            className: st(classes.root, stStates, className),
            'data-hook': this.props['data-hook'],
        }),
            React.createElement("fieldset", { className: classes.container, "aria-label": this.props['aria-label'], "aria-labelledby": this.props['aria-labelledby'] },
                !!label && (React.createElement("legend", { "data-hook": colorPickerFieldsetLabelDataHook, className: classes.label }, label)),
                React.createElement("div", { className: classes.wrapper }, React.Children.map(children, function (item, index) {
                    if (!React.isValidElement(item)) {
                        return null;
                    }
                    return React.cloneElement(item, {
                        onChange: function (event) { return onChange(event, item.props.id); },
                        key: index,
                        className: classes.item,
                        name: name,
                    });
                })))));
    };
    ColorPickerBase.displayName = 'ColorPickerBase';
    ColorPickerBase.Item = ColorPickerItem;
    return ColorPickerBase;
}(React.Component));
export { ColorPickerBase };
//# sourceMappingURL=ColorPicker.base.js.map